import React, { useEffect, useState } from "react";

// PRICING SECTION
import icon05 from "./../../assets/AyurvedaAssets/images/icon-05.svg";
export default function Pricing() {
  // FOR PRICING
  const [activeIndex, setActiveIndex] = useState(0);

  const plans = [
    {
      title: "Free",
      desc: "Plan with premium features",
      price: 45,
      frequency: "mo",
      features: [
        "Get the brain ultrasound",
        "Get the chest xray",
        "Get the femur xray",
        "Get the pelvic ultrasound",
      ],
      imgClass: "img-one",
    },
    {
      title: "Premium",
      desc: "Plan unparalleled benefits",
      price: 59,
      frequency: "mo",
      features: [
        "Get anesthesia support",
        "Get therapeutic exercise",
        "Get wheel management",
        "Metered dose inhaler",
      ],
      imgClass: "img-two",
    },
    {
      title: "Gold",
      desc: "Plan for ultimate excellence",
      price: 84,
      frequency: "mo",
      features: [
        "Get room and board",
        "Occupational therapy",
        "Respiratory therapy",
        "Laboratory services",
      ],
      imgClass: "img-three",
    },
  ];
  return (
    <section className="prt-row padding_top_zero-section pricing-plan-section prt-pricingbox-style1 animation clearfix">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            {/* Section title */}
            <div className="section-title">
              <div className="title-header">
                <h2 className="title">Price and plans</h2>
              </div>
              <div className="title-desc pricing-desc">
                <p>
                  <img
                    width={24}
                    height={24}
                    className="img-fluid"
                    src={icon05}
                    alt="icon"
                  />{" "}
                  Explore competitive pricing and flexible plans{" "}
                  <a
                    className="prt-btn btn-inline prt-btn-size-md prt-btn-color-darkcolor underline p-0"
                    href="contact-us.html"
                  >
                    Make appointment
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="title-desc">
              <p>
                Discover transparent pricing and flexible plans to meet diverse
                needs. From budget-friendly options to comprehensive packages,
                we cater to every requirement
              </p>
            </div>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="row prt-boxes-row-wrapper fadeup-amin">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`prt-box-col-wrapper col-xl-4 col-lg-12 ${
                idx === activeIndex ? "active" : ""
              }`}
              onMouseEnter={() => setActiveIndex(idx)} // hover sets active
            >
              <div className={`featured-pricingplan-style1 ${plan.imgClass}`}>
                <div className="featured-box-info">
                  <div className="featured-pricing-content">
                    <div className="prt-p_table-body">
                      <div className="prt-p_table-title">
                        <h3>{plan.title}</h3>
                        <p>{plan.desc}</p>
                      </div>
                      <div className="prt-p_table-amount">
                        <span className="cur_symbol"></span>${plan.price}
                        <span className="pac_frequency">
                          / {plan.frequency}
                        </span>
                      </div>
                    </div>
                    <ul className="prt-p_table-features">
                      {plan.features.map((f, fidx) => (
                        <li key={fidx}>{f}</li>
                      ))}
                    </ul>
                    <div className="prt-pricing-btn">
                      <a
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                        href="contact-us.html"
                      >
                        Buy Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
